import { UniformSlot } from '@uniformdev/canvas-react';

const UniformVariantContainer = () => <UniformSlot name="content" />;

export default UniformVariantContainer;
